import { Component, Input, inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { SteuerbareResourceInformationen } from '../../../domain/model/steuerbare-resource-informationen.model';
import { AbstractForm } from '../abstract-form.model';
import { FormGroupConfig } from '../form-config.model';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';
import { RegelzoneItem } from '../../../domain/model/regelzone.enum';
import { BilanzierungsmodellItem } from '../../../domain/model/bilanzierungsmodell.enum';
import { MarktpartnerValidator } from '../validator/marktpartner.validator';
import { Feld } from '../../../domain/model/feld.enum';
import { AbrechnungsklasseItem } from '../../../domain/model/abrechnungsklasse.enum';

@Component({
    selector: 'redispatch-steuerbare-resource-sub-form',
    templateUrl: './steuerbare-resource-sub-form.component.html',
    styleUrls: [
        './steuerbare-resource-sub-form.component.scss',
    ],
    standalone: false,
})
export class SteuerbareResourceSubFormComponent extends AbstractForm<SteuerbareResourceInformationen> {

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;

    public readonly MAX_AMOUNT_BETROFFENE_NB = 6;
    public readonly MP_SEPARATOR = MarktpartnerValidator.SEPARATOR;

    @Input({ required: true }) disabled: boolean;
    @Input({ required: true }) readonly: boolean;

    public readonly AbrechnungsklasseItems = AbrechnungsklasseItem.getAll();
    public readonly BilanzierungsmodellItems = BilanzierungsmodellItem.getAll();
    public readonly RegelzoneItems = RegelzoneItem.getAll();
    public readonly Feld = Feld;

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<SteuerbareResourceInformationen> {
        return {
            anschlussNetzbetreiber: [
                {
                    value: '',
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    MarktpartnerValidator.validateSingle(),
                ],
            ],
            anweisenderNetzbetreiber: [
                {
                    value: '',
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    MarktpartnerValidator.validateSingle(),
                ],
            ],
            betroffeneNetzbetreiber: [
                {
                    value: [],
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    MarktpartnerValidator.validateMultiple(this.MAX_AMOUNT_BETROFFENE_NB),
                ],
            ],
            weitereBetroffeneNetzbetreiber: [
                {
                    value: [],
                    disabled: this.disabled || this.readonly,
                },
                [
                    MarktpartnerValidator.validateMultiple(),
                ],
            ],
            abrechnungsklasse: [
                { value: null, disabled: this.disabled || this.readonly },
                MatValidators.required,
            ],
            bilanzierungsmodell: [
                { value: null, disabled: this.disabled || this.readonly },
            ],
            regelzone: [
                { value: null, disabled: this.disabled || this.readonly },
                MatValidators.required,
            ],
        };
    }

    public sanitize(infos: SteuerbareResourceInformationen): SteuerbareResourceInformationen {
        return infos;
    }
}
